import React from 'react';
import TextField from 'material-ui/TextField';

class Description extends React.Component {
    render() {
        const { description, changeField } = this.props;

        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-xs-12'>
                        <TextField 
                            value={description || ''}
                            onChange={(e, value) => {
                                changeField({
                                    field: `description`,
                                    value,
                                });
                            }}
                            hintText="Description"
                            multiLine={true}
                            fullWidth
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Description;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Description.jsx